import React from 'react';
import HeroSection from '../../components/ui/HeroSection';
import AboutSection from './about/AboutSection';
import SkillsSection from './skills/SkillsSection';

function About() {
  return (
    <div>
      <HeroSection navList={['home', 'about']} title="about me" />
      <AboutSection />
      <SkillsSection />
    </div>
  );
}

export default About;
